import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Loader from './components/section/Loader';

// Start Main
import Header from "./components/main/Header";
import Footer from "./components/main/Footer";

// Start Pages
import Home from "./components/pages/Home";
import AbotuUs from "./components/pages/AbotuUs";
import Services from "./components/pages/Services";
import ContactUs from "./components/pages/ContactUs";
import OurTeam from "./components/pages/OurTeam";
import CompanyProfile from "./components/pages/CompanyProfile";

// Start Admin
import AdminProtal from "./components/admin/AdminProtal";
import Employees from "./components/admin/Employees";
import Job from "./components/admin/Job";
import Inbox from "./components/admin/Inbox";
import Subscribe from "./components/admin/Subscribe";

// Start Hooks
import Top from './components/Top';
import ScrollToTop from './components/ScrollToTop';
import UseScrollAnimation from './hooks/UseScrollAnimation';

const App = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/ma/admin");

  return (
    <>
      <Loader />
      {!isAdminRoute && <Header />}
      <Top />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AbotuUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/company-profile" element={<CompanyProfile />} />

        {/* Admin Pages */}
        <Route path="/ma/admin/view" element={<AdminProtal />} />
        <Route path="/ma/admin/view/employees" element={<Employees />} />
        <Route path="/ma/admin/view/job" element={<Job />} />
        <Route path="/ma/admin/view/inbox" element={<Inbox />} />
        <Route path="/ma/admin/view/subscribe" element={<Subscribe />} />
      </Routes>

      {!isAdminRoute && <Footer />}
      <ScrollToTop />
      <UseScrollAnimation />
    </>
  );
};

export default App;